// pages/Connector/Connectors.js
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box, Typography, Grid, Card, CardContent, CardActions,
  Button, Avatar
} from "@mui/material";
import {
  Google, Cloud, Group, SupportAgent, AccessTime, School, RateReview,
  ArrowForward as ArrowForwardIcon
} from "@mui/icons-material";

export default function Connectors() {
  const navigate = useNavigate();
  const { chatbotId: paramsChatbotId } = useParams();

  useEffect(() => {
    document.title = "Connectors | KlonIT Web Application";
  }, []);

  const connectors = [
    {
      title: "Google Drive",
      description: "Sync your data from Google Drive and connect with chatbot.",
      icon: <Google sx={{ fontSize: 60, color: "#34A853" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/gdrive`,
      color: "#34A853",
    },
    {
      title: "Google Reviews",
      description: "Sync your Google Business Profile reviews and ratings into your chatbot.",
      icon: <RateReview sx={{ fontSize: 60, color: "#FBBC05" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/google-reviews`,
      color: "#FBBC05",
    },
    {
      title: "One Drive",
      description: "Sync your data from One Drive and connect with chatbot.",
      icon: <Cloud sx={{ fontSize: 60, color: "#0078D4" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/onedrive`,
      color: "#0078D4",
    },
    {
      title: "Salesforce",
      description: "Manage Salesforce leads directly from your dashboard.",
      icon: <Group sx={{ fontSize: 60, color: "#FF9800" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/salesforce`,
      color: "#FF9800",
    },
    {
      title: "Instagram",
      description:
        "Analyze post comments and train your chatbot with social insights.",
      icon: <Group sx={{ fontSize: 60, color: "#E1306C" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/instagram`,
      color: "#E1306C",
    },
    {
      title: "Twitter/X",
      description:
        "Analyze post comments and train your chatbot with social insights.",
      icon: <Group sx={{ fontSize: 60, color: "#16147c" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/twitter`,
      color: "#16147c",
    },
    {
      title: "ServiceNow",
      description:
        "Integrate with ServiceNow to manage incidents, requests, and knowledge data seamlessly.",
      icon: <SupportAgent sx={{ fontSize: 60, color: "#00ADEF" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/servicenow`,
      color: "#00ADEF",
    },
    {
      title: "LMS",
      description: "Learning Management System - Manage courses and students.",
      icon: <School sx={{ fontSize: 60, color: "#1976d2" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/lms`,
      color: "#1976d2",
    },
    {
      title: "Prayer Timing",
      description:
        "Manage Islamic prayer times calendar and train your chatbot with prayer schedules.",
      icon: <AccessTime sx={{ fontSize: 60, color: "#1B5E20" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/prayer-timing`,
      color: "#1B5E20",
    },
  ];

  return (
    <Box sx={{ p: 3, mt: 10 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700}>
          Connectors
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Integrate external services and platforms with your chatbot
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {connectors.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-4px)",
                },
              }}
              onClick={() => navigate(card.link)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: "center", pt: 4 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: `${card.color}15`,
                    margin: "0 auto 16px",
                  }}
                >
                  {card.icon}
                </Avatar>
                <Typography variant="h5" gutterBottom fontWeight={600}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "center", pb: 3 }}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ bgcolor: card.color }}
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
